import type { ViewStyle } from 'react-native';
import styles from './styles';

enum GroupUpdateTypesEnum {
  Lock = 'LOCK',
  Unlock = 'UNLOCK',
  Threshold = 'THRESHOLD',
}

type ConfirmationActionText = {
  /** The text value for the confirmation action */
  textValue: string;
  /** The text style */
  textStyle: ViewStyle | null;
};

type GetConfirmationActionText = (action: GroupUpdateTypesEnum | null) => ConfirmationActionText;

export const getConfirmationActionText: GetConfirmationActionText = action => {
  switch (action) {
    case GroupUpdateTypesEnum.Lock:
      return {
        textValue: 'Lock',
        textStyle: styles.cancel,
      };
    case GroupUpdateTypesEnum.Unlock:
      return {
        textValue: 'Unlock',
        textStyle: styles.confirm,
      };
    case GroupUpdateTypesEnum.Threshold:
      return {
        textValue: 'update threshold number for',
        textStyle: styles.link,
      };
    default:
      return {
        textValue: '',
        textStyle: null,
      };
  }
};

export default GroupUpdateTypesEnum;
